module.exports = __webpack_public_path__ + "static/dell-114b5584737d5ee4dd1efda8fc87fc6f.png";